import { MagpieConnection } from 'magpie-lib/connection';
import { AudienceFilter, MagpieConfigManager } from 'magpie-lib/models';
import { useEffect } from 'react';
import { useEffectEvent } from '../hooks/useEffectEvent';
import { getBenderProject } from './bender';
import Raven from 'raven-js';
export const useMagpieTopic = ({
  topic,
  message,
  onMessage
}) => {
  const skip = !onMessage;
  const stableOnMessage = useEffectEvent(onMessage);
  useEffect(() => {
    if (skip) {
      return;
    }
    const unsubscribe = MagpieConnection.get().useTopic(topic).on(message.getType(), stableOnMessage);
    return () => unsubscribe();
  }, [message, skip, stableOnMessage, topic]);
};
export const buildAudience = win => {
  const builder = AudienceFilter.builder().crossTab(false).crossPortal(false);
  try {
    const benderProject = getBenderProject(win);
    if (!benderProject) {
      throw new Error();
    }
    const isEmbeddableApp = benderProject === 'collaboration-sidebar-embeddable';
    const targetProject = isEmbeddableApp ? getBenderProject(win.parent) : benderProject;
    if (!targetProject) {
      throw new Error();
    }
    builder.byApplication({
      name: targetProject
    });
    const embeddableAppName = `${targetProject}-collaboration-sidebar-embeddable`;
    builder.byApplication({
      name: embeddableAppName
    });
    if (isEmbeddableApp) {
      const cfgManager = MagpieConfigManager.getInstance();
      cfgManager.set('appName', embeddableAppName);
    }
  } catch (error) {
    /**
     * In test environments, we won't have any of the product metadata so we fallback
     * to a less restrictive audience. We also want to capture this error so we can can flag
     * if it is happening in contexts we don't expect.
     */
    Raven.captureException(new Error('Unable to determine audience for Collaboration Sidebar messaging, application may experience undefined behavior'));
    console.warn('Unable to determine audience for Collaboration Sidebar messaging, application may experience undefined behavior');
  }
  const audience = builder.build();
  return audience;
};
export const CollaborationSidebarAudience = buildAudience(window);